module.exports = __webpack_public_path__ + "b6ad71701df020063bd86fae0e8f061c.mp4";